import { Paper, styled } from '@lingoda/ui';

export const ClassDetailsTilePaperStyled = styled(Paper)({
    borderWidth: '1px',
    overflow: 'hidden',
});
